import React from 'react'
import HeaderSection from '../../components/headersection/HeaderSection'
import useAppContext from '../../hook/useAppContext'
import FriendRow from './FriendRow'
import './friends.css'

const Friends = () => {

      const {user} = useAppContext()
      const {friends} = user 

      if(friends.code) return 

      const amount = friends.length 

      return (
            <div className="wrapper_friends">
                  <HeaderSection title={`Friends`} />
                  <div className="friends_amount flex">{amount}</div>
                  <div className="friends_content__group">
                        {
                              friends.map((item, index) => (
                                    <FriendRow friend={item} key={index}/>
                              ))
                        }
                  </div>
            </div>
      )
}

export default Friends
